{
  "version": 1,
  "asset_id": "ab330e8f-993c-4b77-a625-04c4beb88076",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/ab330e8f-993c-4b77-a625-04c4beb88076/mrdrive-circles.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/ab330e8f-993c-4b77-a625-04c4beb88076/mrdrive-circles.png",
  "original_filename": "mrdrive-circles.png",
  "size": 2839249,
  "content_type": "image/png",
  "created_at": "2026-08-21T14:38:08Z"
}
